import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { AppColors } from '../Utils/helper/AppColors';
import { BackIcon } from './Icons/Icons';
import CustomInfoTooltip from './CustomInfoTooltip';

export default function PageHeading(props) {
	const { title, subTitle, titleSize = 24, subTitleSize = 14, infoTooltip ,renderRight, onBackClick , wrapContext = false } = props;
	return (
		<Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems="flex-start" {...props} gap={1}>
			<Stack direction="row" gap={1} alignItems="flex-start">
				{typeof onBackClick == 'function' && (
					<IconButton onClick={onBackClick} size="small">
						<BackIcon size={26} />
					</IconButton>
				)}

				<Stack mr="auto">
					<Stack direction="row" gap={1} alignItems="center" >
                    <Typography fontSize={titleSize} color={AppColors.HEADING_TITLE} fontWeight={600} lineHeight="130%"  sx={{ maxWidth: wrapContext ? '500px' : 'none' , whiteSpace: wrapContext ? 'nowrap' : 'normal', overflow: wrapContext ? 'hidden' : 'visible', textOverflow: wrapContext ? 'ellipsis' : 'visible'  }}>
                        {title}  
                    </Typography>
                    { infoTooltip && infoTooltip !== '' && <CustomInfoTooltip title={infoTooltip} /> }
                    </Stack>
					{subTitle && (
						<Typography fontSize={subTitleSize} color={AppColors.HEADING_SUBTITLE} fontWeight={400} lineHeight="150%" fontFamily="Poppins">
							{subTitle}
						</Typography>
					)}
				</Stack>
			</Stack>

			{renderRight}
		</Stack>
	);
}
